// Single source of truth for API URLs, colocated with API_Requests.js.
//
// Pure JS (no import.meta.env, no jQuery/Cookies/router imports) so it can
// also be imported directly from Node by vite.config.js, which uses it to
// generate public/shared/env-config.js for the vanilla (non-Vite) scripts in
// public/*/js/API_Requests.js — that's what lets the SMPTE show player and
// Reports pages read real per-environment URLs instead of hardcoded prod ones.

export function getAPIUrls(ENVIRONMENT) {
	const API = {};

	switch (ENVIRONMENT) {
		case 'PRODUCTION': //Fall through
		case 'BETA': //Fall through
		case 'ALPHA':
			API.COBRA_PORTAL_URL = 'https://portal.cobrafiringsystems.com';

			API.COBRA_PORTAL_API_URL = 'https://api.portal.cobrafiringsystems.com';

			API.CRS_API_URL = 'https://api.crs.cobrafiringsystems.com';

			API.COBRA_ADMIN_API_URL = 'https://cobra.api.cobrashowcreator.com';

			API.CSC_API_URL = 'https://api.cobrashowcreator.com';

			API.CSC_AUDIO_URL = 'https://audio-api.cobrashowcreator.com';

			API.CENTRAL_FILE_SERVER = 'https://audio-api.cobrashowcreator.com';

			API.IGNITE_API_URL = 'https://api.ignitefiringsystems.com';

			API.ELEVATE_UI_URL = ENVIRONMENT === 'PRODUCTION' ? 'https://cobrashowcreator.com' : 'https://beta.cobrashowcreator.com';

			API.BASE_API_URL = API.CSC_API_URL;

			API.DESKTOP_AGENT = 'http://localhost:12345';

			break;

		case 'STAGING': //Fall through
		case 'DEVELOPMENT': //Fall through
		default:
			API.COBRA_PORTAL_URL = 'https://beta.portal.cobrafiringsystems.com';
			// API.COBRA_PORTAL_URL = 'http://localhost:3333';

			API.COBRA_PORTAL_API_URL = 'https://api.beta.portal.cobrafiringsystems.com';
			// API.COBRA_PORTAL_API_URL = 'http://localhost:3085';

			API.CRS_API_URL = 'https://api.crs.cobrafiringsystems.com';
			// API.CRS_API_URL = "http://localhost:3095"

			API.COBRA_ADMIN_API_URL = 'https://cobra.api.cobrashowcreator.com';
			// API.COBRA_ADMIN_API_URL = 'http://localhost:3070'

			API.CSC_API_URL = 'https://dev-api.cobrashowcreator.com';
			// API.CSC_API_URL = 'http://localhost:3050';

			API.CSC_AUDIO_URL = 'https://audio-api.cobrashowcreator.com';
			// API.CSC_API_URL = 'https://dev-api.cobrashowcreator.com';

			API.CENTRAL_FILE_SERVER = 'https://audio-api.cobrashowcreator.com';
			// API.CENTRAL_FILE_SERVER = "http://localhost:3060"

			API.IGNITE_API_URL = 'https://api.ignitefiringsystems.com';

			API.ELEVATE_UI_URL = 'https://beta.cobrashowcreator.com';

			API.BASE_API_URL = API.CSC_API_URL;
			API.DESKTOP_AGENT = 'http://localhost:12345';

			break;
	}

	API.COBRA_PORTAL_BASE_API_URL = API.COBRA_PORTAL_API_URL;
	API.COBRA_PORTAL_BASE_UI_URL = API.COBRA_PORTAL_URL;

	return API;
}
